import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import { NotificationAction } from '../Actions/Models/NotificationActionModel';
import { Types } from 'Modules/NotificationModule';

export type State = Types.NotificationStore;

export const initialState: State = {
    notifications: null,
    activeNotification: null,
    notificationsParams: {
        first: 0,
        max: 10
    }
};

export function notificationReducer(state: State = initialState, action: NotificationAction): State {
    switch (action.type) {
        case ActionTypes.NOTIFICATION.GET_NOTIFICATIONS: {
            const notificationsClone = state.notifications ? [...state.notifications.paginatedList.results] : [];
            const payloadClone = { ...action.payload.notifications };
            payloadClone.paginatedList.results = notificationsClone.concat(payloadClone.paginatedList.results);
            return {
                ...state,
                notifications: payloadClone
            };
        }
        case ActionTypes.NOTIFICATION.READ_NOTIFICATION:
            const notifications = { ...state.notifications };
            const indx = notifications.paginatedList.results.findIndex((e, i) => e.id === action.payload.notificationId);
            notifications.paginatedList.results[indx].read = true;
            notifications.unreadNotifications = notifications.unreadNotifications - 1;
            return {
                ...state,
                notifications
            };

        case ActionTypes.NOTIFICATION.ADD_NEW_NOTIFICATION: {
            const notificationsClone = { ...state.notifications };
            notificationsClone.paginatedList.results.unshift(action.payload.newNotification);
            notificationsClone.unreadNotifications += 1;
            return {
                ...state,
                notifications: notificationsClone
            };
        }
        case ActionTypes.NOTIFICATION.UPDATE_PARAMS: {
            const itemsCountToAdd = 10;
            const notificationsClone = { ...state.notifications };
            const params = { ...state.notificationsParams };
            params.first = notificationsClone.paginatedList.totalCount > params.first + 10 ? params.first + itemsCountToAdd : notificationsClone.paginatedList.totalCount;
            return {
                ...state,
                notificationsParams: params
            };
        }
        case ActionTypes.NOTIFICATION.SET_ACTIVE_NOTIFICATION: {
            return {
                ...state,
                activeNotification: action.payload.notification
            };
        }
        case ActionTypes.NOTIFICATION.CLEAR_NOTIFICATIONS: {
            const newNotifications = state.notifications
            newNotifications.unreadNotifications = 0
            newNotifications.paginatedList.results = [...newNotifications.paginatedList.results]
              .map((notification) => ({ ...notification, read: true }));

            return {
                ...state,
                activeNotification: initialState.activeNotification,
                notifications: newNotifications
            };
        }
        case ActionTypes.NOTIFICATION.OPEN_SSE_NOTIFICATION:
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/NotificationReducer.ts